<template>
  <VWidget content-class="pa-0" css-class="flex-grow-1">
    <template slot="title">{{ $t('title') }}</template>
    <template slot="content" v-if="loading">
      <v-loading />
    </template>
    <template slot="content" v-else>
      <v-list v-if="hasInvitations">
        <v-list-item v-for="invite in invitations" :key="invite.id">
          <v-list-item-avatar size="28">
            <img v-if="invite.organization.avatar" :src="invite.organization.avatar" />
            <v-icon v-else v-text="$vuetify.icons.values.organization"></v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ invite.organization.display }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon
              small
              color="success"
              v-text="$vuetify.icons.values.stateSuccess"
              v-if="invite.resolved && invite.accepted"
            />
            <v-icon
              small
              color="error"
              v-text="$vuetify.icons.values.stateFailure"
              v-else-if="invite.resolved && !invite.accepted"
            />
            <v-btn icon small text color="warning darken-1" @click="showInvitation(invite)" v-else>
              <v-icon small v-text="$vuetify.icons.values.statePending" />
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <h4 class="pa-4 text-h6 text-center" v-else>{{ $t('noInvitation') }}</h4>
    </template>
  </VWidget>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { VWidget, VLoading } from '@argon/app/components'
import { NAMESPACE } from '../store'
export default {
  components: {
    VWidget,
    VLoading
  },
  data: () => ({ loading: true }),
  computed: {
    ...mapState(NAMESPACE, ['invitations']),
    hasInvitations() {
      return this.invitations.length > 0
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['listInvitations']),
    showInvitation(invite) {
      this.$router.push({
        name: 'invitation',
        params: {
          ...this.$router.params,
          inviteRefid: invite.refid
        }
      })
    }
  },
  created() {
    this.listInvitations()
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
  }
}
</script>

<i18n>
{
  "en": {
    "noInvitation": "You have no invitation",
    "title": "@:labels.invitations"
  },
  "fr": {
    "noInvitation": "Vous n'avez pas d'invitation",
    "title": "@:labels.invitations"
  }
}
</i18n>
